export default {
  state: {
    loading: [],
  },
  getters: {
    isLoading: state => (options = {}) => {
      var id = options.id;
      var scope = options.scope;
      if (id) {
        return state.loading.find(x => x.loadingId === id) !== undefined;
      } else if (scope) {
        return state.loading.find(x => x.scope === scope) !== undefined;
      } else {
        return state.loading.length > 0;
      }
    },
  },
  mutations: {
    addLoading(state, payload) {
      state.loading.push(payload); // Use Array instead of Set for underlying Vue reactivity
    },
    removeLoading(state, payload) {
      const index = state.loading.findIndex(object => {
        return object.loadingId === payload.loadingId;
      });
      if (index >= 0) {
        state.loading.splice(index, 1);
      }
    },
    reset(state) {
      state.loading = [];
    },
  },
  actions: {
    async load({ commit, dispatch }, scope = 'global') {
      let loading = {};
      loading.loadingId = await dispatch('getLoadingId');
      loading.scope = scope;
      commit('addLoading', loading);

      return loading;
    },
    unload({ commit }, loading) {
      commit('removeLoading', loading);
    },
    getLoadingId({ state }) {
      var id = Math.random().toString(16).slice(2);

      var counter = 0;
      while (state.loading.includes(id) && counter < 20) {
        id = Math.random().toString(16).slice(2);
        counter += 1;
      }
      return id;
    },
    toggleLoad({ dispatch, getters }, payload) {
      getters.loading(payload)
        ? dispatch('load', payload)
        : dispatch('unload', payload);
    },
  },
};